import { TransactionTypeEnum } from "../enums/TransactionTypeEnum";
import { TransactionsFilterData } from "@/model/communication/cashReport/TransactionsFilterData";

export class CashReportUserLongTaskInputData {
    dateFilterType: number;
    startDate: Date;
    endDate: Date;
    transTypes: TransactionTypeEnum[];
    userID: string;
    installationNames: string[] = null;
    folderIds: number[] = null;
    userId: string;
    userOrganization: string;
    userInfo: string;
    shiftNumber: string;
    channelId: string;
    serialNumber: string;
    loadIntegrationFeedback: boolean = true;
    exportType: string = "csv";

    constructor(exportType: string, transactionFilterData?: TransactionsFilterData) {
        if (transactionFilterData != null && transactionFilterData != undefined) {
            this.dateFilterType = transactionFilterData.dateFilterType;
            this.startDate = new Date(
                Date.UTC(
                    transactionFilterData.startDate.getFullYear(),
                    transactionFilterData.startDate.getMonth(),
                    transactionFilterData.startDate.getDate(),
                    transactionFilterData.startDate.getHours(),
                    transactionFilterData.startDate.getMinutes(),
                    transactionFilterData.startDate.getSeconds()
                )
            );
            this.endDate = new Date(
                Date.UTC(
                    transactionFilterData.endDate.getFullYear(),
                    transactionFilterData.endDate.getMonth(),
                    transactionFilterData.endDate.getDate(),
                    transactionFilterData.endDate.getHours(),
                    transactionFilterData.endDate.getMinutes(),
                    transactionFilterData.endDate.getSeconds()
                )
            );
            this.channelId = transactionFilterData.channelId;
            this.shiftNumber = transactionFilterData.shiftNumber;
            this.userID = transactionFilterData.userId;
            this.userOrganization = transactionFilterData.userOrganization;
            this.userInfo = transactionFilterData.userInfo;
            this.transTypes = transactionFilterData.transTypes;
            this.serialNumber = transactionFilterData.serialNumber;
            this.loadIntegrationFeedback = transactionFilterData.loadIntegrationFeedback;
        }
        if (exportType) this.exportType = exportType;
    }
}
